import React from 'react';
import BrandHeader from '../components/BrandHeader';

/**
 * Kept as a thin alias so the login pages keep reading clearly. The markup and
 * styling live in BrandHeader, shared with the product pages - it used to be
 * duplicated inline in both logins.
 */
const LoginHeader = () => <BrandHeader />;

export default LoginHeader;
